export const enum AuthEvents {
  LoginClicked = "login-clicked",
}
